/* eslint-disable react/jsx-indent */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable react/require-default-props */
/* eslint-disable react/forbid-prop-types */

import React, { memo } from 'react';
import PropTypes from 'prop-types';
import {
  activatedPingableStyle,
  carrierFormat,
  deactivatedPingableStyle,
  SIM_STATUS,
} from './helper';

const SimInformation = memo(({ sims }) => {
  const pingable = status => {
    const formattedStatus = SIM_STATUS[status];
    const style = status === 'Activated' ? activatedPingableStyle : deactivatedPingableStyle;

    return (
      <span>
        Status: <span style={style}>{formattedStatus}</span>
      </span>
    );
  };

  return (
    <div className="modam mb-2">
      {sims.map(item => (
        <div className='sims-information'>
          <span>
            Carrier: <span> {carrierFormat[item.carrier]} </span>
          </span>
          <span>
            SIM: <span> {item?.connection?.iccid} </span>
          </span>
          <span>
            IMEI: <span> {sims[0]?.connection?.imei || sims[1]?.connection?.imei} </span>
          </span>
          {pingable(item.status)}
          <span>{`IP: ${item.ip}`}</span>
        </div>
      ))}
    </div>
  );
});

SimInformation.propTypes = {
  sims: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.object)),
};

export default SimInformation;
